<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <h2>Vehicle Maintenance Reminder</h2>
      </div>
      <div class="col-lg-12">
        <card>
          <tabs type="primary">
            <tab-pane label="Preventive Maintenace">
              <el-table
                :data="tableMaintenance"
                height="500"
                :header-cell-style="{
                  background: 'transparent',
                  border: 'none',
                  borderBottom: '0.5px solid #3d3f51',
                }"
                :cell-style="{
                  border: 'none',
                  borderBottom: '0.5px solid #3d3f51',
                }"
              >
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Site"
                  property="SiteName"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Department"
                  property="DeptName"
                ></el-table-column>
                <el-table-column
                  min-width="180"
                  sortable
                  align="center"
                  label="Vehicle Category"
                  property="VehCatName"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Manufacture"
                  property="VecManuf"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Vehicle No"
                  property="VehRegNo"
                ></el-table-column>
                <el-table-column
                  min-width="180"
                  sortable
                  align="center"
                  label="Last Odometer"
                  property="LastOdometer"
                ></el-table-column>
                <el-table-column
                  min-width="190"
                  sortable
                  align="center"
                  label="Current Odometer"
                  property="CurrentOdometer"
                ></el-table-column>
                <el-table-column
                  min-width="180"
                  sortable
                  align="center"
                  label="Last Service Date"
                  property="LastServiceDate"
                ></el-table-column>
                <el-table-column
                  min-width="180"
                  sortable
                  align="center"
                  label="Next Service Date"
                  property="NextServiceDate"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Status"
                  property="StatusName"
                ></el-table-column>
              </el-table>
            </tab-pane>

            <tab-pane label="Road Tax / Insurance">
              <el-table
                :data="tableRoadtax"
                height="500"
                :header-cell-style="{
                  background: 'transparent',
                  border: 'none',
                  borderBottom: '0.5px solid #3d3f51',
                }"
                :cell-style="{
                  border: 'none',
                  borderBottom: '0.5px solid #3d3f51',
                }"
              >
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Site"
                  property="SiteName"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Department"
                  property="DeptName"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Vehicle No"
                  property="VehRegNo"
                ></el-table-column>
                <el-table-column
                  min-width="180"
                  sortable
                  align="center"
                  label="Vehicle Category"
                  property="VehCatName"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Manufacture"
                  property="VecManuf"
                ></el-table-column>
                <el-table-column
                  min-width="190"
                  sortable
                  align="center"
                  label="Current Odometer"
                  property="VehOdometer"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Status"
                  property="StatusName"
                ></el-table-column>
                <el-table-column
                  min-width="180"
                  sortable
                  align="center"
                  label="Expiration Date"
                  property="ExpirationDate"
                ></el-table-column>
              </el-table>
            </tab-pane>

            <tab-pane label="PUSPAKOM">
              <el-table
                :data="tablePUSPAKOM"
                height="500"
                :header-cell-style="{
                  background: 'transparent',
                  border: 'none',
                  borderBottom: '0.5px solid #3d3f51',
                }"
                :cell-style="{
                  border: 'none',
                  borderBottom: '0.5px solid #3d3f51',
                }"
              >
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Site"
                  property="SiteName"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Department"
                  property="DeptName"
                ></el-table-column>
                <el-table-column
                  min-width="180"
                  sortable
                  align="center"
                  label="Vehicle Category"
                  property="VehCatName"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Manufacture"
                  property="VecManuf"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Vehicle No"
                  property="VehRegNo"
                ></el-table-column>
                <el-table-column
                  min-width="190"
                  sortable
                  align="center"
                  label="Current Odometer"
                  property="VehOdometer"
                ></el-table-column>
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Status"
                  property="StatusName"
                ></el-table-column>
                <el-table-column
                  min-width="180"
                  sortable
                  align="center"
                  label="Inspection Date"
                  property="InspectionDate"
                ></el-table-column>
              </el-table>
            </tab-pane>
          </tabs>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem } from "src/components";
import { Table, TableColumn } from "element-ui";

export default {
  components: {
    TabPane,
    Tabs,
    Collapse,
    CollapseItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      activeName: "first",
      tableMaintenance: [],
      tableRoadtax: [],
      tablePUSPAKOM: [],
    };
  },

  methods: {
    getMaintenance() {
      this.$http.get(":9993/api/v1/reminder/maintenance").then((res) => {
        if (!res.error) {
          let data = res.message;
          console.log(data);
          for (let i = 0; i < data.length; i++) {
            let obj = {
              LastServiceDate:
                data[i].LastServiceDate == "" ? "-" : data[i].LastServiceDate,
              NextServiceDate: data[i].NextServiceDate,
              VehRegNo: data[i].VehicleNo,
              CurrentOdometer: data[i].CurrentOdometer,
              LastOdometer:
                data[i].LastOdometer == "" ? "-" : data[i].LastOdometer,
              SiteName: data[i].SiteName,
              DeptName: data[i].DeptName,
              VecManuf: data[i].Manufacture,
              VehCatName: data[i].CategoryName,
              StatusName: data[i].StatusName,
            };

            this.tableMaintenance.push(obj);
          }
        }
      });
    },
    getRoadtax() {
      this.$http.get(":9993/api/v1/reminder/roadtax").then((res) => {
        if (!res.error) {
          let data = res.message;
          console.log(data);
          for (let i = 0; i < data.length; i++) {
            let obj = {
              ExpirationDate: data[i].RoadTaxDate,
              VehRegNo: data[i].VehicleNo,
              VehOdometer: data[i].Odometer,
              SiteName: data[i].SiteName,
              DeptName: data[i].DeptName,
              VecManuf: data[i].Manufacture,
              VehCatName: data[i].CategoryName,
              StatusName: data[i].StatusName,
            };

            this.tableRoadtax.push(obj);
          }
        }
      });
    },
    getPuspakom() {
      this.$http.get(":9993/api/v1/reminder/puspakom").then((res) => {
        if (!res.error) {
          let data = res.message;
          console.log(data);
          for (let i = 0; i < data.length; i++) {
            let obj = {
              VehRegNo: data[i].VehicleNo,
              VehOdometer: data[i].Odometer,
              SiteName: data[i].SiteName,
              DeptName: data[i].DeptName,
              VecManuf: data[i].Manufacture,
              VehCatName: data[i].CategoryName,
              StatusName: data[i].StatusName,
              InspectionDate: data[i].PuspakomDate,
            };

            this.tablePUSPAKOM.push(obj);
          }
        }
      });
    },
  },
  created() {
    this.getMaintenance();
    this.getRoadtax();
    this.getPuspakom();
  },
};
</script>
<style lang="scss"></style>
